import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { useCliente } from "../context/ClienteContext";

const DetalhesSessaoAula = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { parametros } = useCliente();

  const [sessao, setSessao] = useState(null);

  useEffect(() => {
    const carregar = async () => {
      try {
        const response = await axios.get(`/api/sessoes_aula/${id}`);
        setSessao(response.data);
      } catch (error) {
        console.error("Erro ao carregar sessão:", error);
      }
    };

    carregar();
  }, [id]);


  const handleExcluir = async () => {
    if (!window.confirm("Tem certeza que deseja excluir esta sessão?")) return;
    try {
      await axios.delete(`/api/sessoes_aula/${id}`);
      alert("Sessão excluída com sucesso.");
      navigate("/minhas-sessoes");
    } catch (error) {
      console.error("Erro ao excluir sessão:", error);
      alert("Erro ao excluir sessão.");
    }
  };

  if (!sessao) return <p>Carregando sessão...</p>;

  return (
    <div className="form-wrapper">
      <h2 className="form-title">Detalhes da Sessão</h2>

      <div className="form-group">
        <label>Nome da Sessão:</label>
        <p>{sessao.nome}</p>
      </div>

      <div className="form-group">
  <label style={{ marginTop: "24px", display: "block" }}>Data da criação/atualização:</label>
  <p>{sessao.atualizado_em || sessao.criado_em}</p>
  </div>

<div className="form-group full-width">
  <label style={{ marginTop: "24px", display: "block" }}>Resumo da Sessão:</label>
  <div
    style={{
      backgroundColor: "#f9f9f9",
      padding: "12px",
      border: "1px solid #ddd",
      borderRadius: "6px",
      whiteSpace: "pre-wrap"
    }}
  >
    {sessao.resumo}
  </div>
</div>


      <div className="form-actions">
        <button onClick={() => navigate("/minhas-sessoes")} className="btn btn-secondary">Voltar</button>
        <button className="btn btn-primary" onClick={() => navigate(`/editar-sessao/${id}`)}>Editar</button>
        <button className="btn btn-danger" onClick={handleExcluir}>Excluir</button>
      </div>

    </div>
  );
};

export default DetalhesSessaoAula;
